module.exports = __webpack_public_path__ + "static/media/LGP-Logo.eeea32d9.png";